document.addEventListener('DOMContentLoaded', () => {
   if (document.querySelector('#wcl-profile-popup')) {
      const modal = document.getElementById('wcl-profile-popup');
      const tabs = modal.querySelectorAll('.wcl-sidebar-tabs__item');
      const tabContents = modal.querySelectorAll('.wcl-modal-tab');
      const sidebar = modal.querySelector('.wcl-modal-sidebar');
      const tabsContent = modal.querySelector('.wcl-modal-tabs-content');
      const backButtons = modal.querySelectorAll('.wcl-modal-tab__back');

      //Tab switching
      tabs.forEach(tab => {
         tab.addEventListener('click', function () {

            // Remove active class from all tabs and content blocks
            tabs.forEach(tab => tab.classList.remove('active'));
            tabContents.forEach(content => content.classList.remove('active'));

            if (window.innerWidth >= 577) {
               // Add active class to the current tab
               tab.classList.add('active');
            } else {
               // Add hide class to sidebar and show class to tabs content
               if (sidebar) {
                  sidebar.classList.add('hide');
               }
               if (tabsContent) {
                  tabsContent.classList.add('show');
               }
            }

            // Getting the value of the data-tab attribute
            const tabName = tab.getAttribute('data-tab');

            // Find the corresponding content block by ID and add active class to it
            const activeTabContent = document.getElementById(`wcl-modal-tab-${tabName}`);
            if (activeTabContent) {
               activeTabContent.classList.add('active');
            }
         });
      });


      //Back to sidebar
      backButtons.forEach(button => {
         button.addEventListener('click', function () {
            tabsContent.classList.remove('show');
            sidebar.classList.remove('hide');
         });
      });
   }


   //Trim text in "Favourites Room" cards if the number of characters is greater than 27
   const textTruncation = () => {
      const descriptions = document.querySelectorAll('.wcl-room-characteristics__description');

      if (descriptions.length === 0) {
         return;
      }

      descriptions.forEach(description => {
         let fullText = description.textContent;

         if (window.innerWidth < 577) {
            if (fullText.length > 27) {
               description.textContent = fullText.slice(0, 27) + '...';
            }
         } else {
            description.textContent = fullText;
         }
      });
   };

   window.addEventListener('resize', textTruncation);
   textTruncation();
});